module.exports = __webpack_public_path__ + "static/media/jakub-cto.52843e42.png";